export interface TextareaConfig {
    elements: string;
    container?: HTMLElement;
}

export class Textarea {
    private readonly elements: NodeListOf<HTMLInputElement>;
    private container?: HTMLElement;

    constructor({elements, container}: TextareaConfig) {
        this.elements = container
            ? container.querySelectorAll(elements)
            : document.querySelectorAll(elements);
        this.init();
    }

    public static setSize(element: HTMLInputElement): void {
        element.setAttribute(`style`, `height: ${element.scrollHeight}px; overflow-y:hidden;`);
    }

    public static resize(element: HTMLInputElement): void {
        element.style.height = `auto`;
        element.style.height = `${element.scrollHeight}px`;
    }

    init(): void {
        this.elements.forEach(element => {
            if (element.tagName === `TEXTAREA`) {
                Textarea.setSize(element);
                element.addEventListener('input', () => Textarea.resize(element), false);
            }
        });
    }
}